document.addEventListener('click',function(e){const el=e.target.closest('[data-main-image]');if(el){const main=document.querySelector('#MainProductImage');if(main){main.src=el.dataset.mainImage;main.srcset='';}}});
// Quantity selector: submit chosen quantity with native Shopify product form.
document.addEventListener('click', function(event) {
  var button = event.target.closest('[data-quantity-step]');
  if (!button) return;
  var group = button.closest('.quantity-selector');
  var input = group && group.querySelector('input[name="quantity"]');
  if (!input) return;
  var step = Number(button.getAttribute('data-quantity-step')) || 0;
  var current = parseInt(input.value, 10);
  input.value = String(Math.max(1, (Number.isFinite(current) ? current : 1) + step));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
document.addEventListener('change', function(event) {
  var input = event.target;
  if (!input.matches('.quantity-selector input[name="quantity"]')) return;
  var value = parseInt(input.value, 10);
  input.value = String(Number.isFinite(value) ? Math.max(1, value) : 1);
});

// V7: multi-variant order builder. Adds every chosen variant to Shopify in one request.
(function(){
  const root=document.querySelector('[data-variant-order]');
  if(!root)return;
  const rows=Array.from(root.querySelectorAll('[data-variant-id]'));
  const submit=root.querySelector('[data-variant-submit]');
  const feedback=root.querySelector('[data-variant-feedback]');
  const total=root.querySelector('[data-variant-total]');
  const priceTotal=root.querySelector('[data-variant-price-total]');
  const currency=window.Shopify && window.Shopify.currency && window.Shopify.currency.active || "USD";
  const locale="en-US";
  function refresh(){
    let count=0,price=0;
    for(const row of rows){
      const input=row.querySelector('[data-variant-quantity]');
      const qty=Math.max(0,parseInt(input.value,10)||0);
      count+=qty;price+=qty*(Number(row.dataset.variantPrice)||0);
    }
    total.textContent=String(count);
    priceTotal.textContent=new Intl.NumberFormat(locale,{style:'currency',currency:currency}).format(price/100);
    submit.disabled=count===0;
  }
  root.addEventListener('click',function(e){
    const button=e.target.closest('[data-quantity-step]');
    if(!button||button.disabled)return;
    const input=button.closest('.quantity-selector').querySelector('[data-variant-quantity]');
    input.value=String(Math.max(0,(parseInt(input.value,10)||0)+(parseInt(button.dataset.quantityStep,10)||0)));
    refresh();
  });
  root.addEventListener('input',function(e){if(e.target.matches('[data-variant-quantity]'))refresh()});
  root.addEventListener('change',function(e){if(e.target.matches('[data-variant-quantity]')){e.target.value=String(Math.max(0,parseInt(e.target.value,10)||0));refresh()}});
  submit.addEventListener('click',async function(){
    const items=rows.map(row=>({id:Number(row.dataset.variantId),quantity:Math.max(0,parseInt(row.querySelector('[data-variant-quantity]').value,10)||0)})).filter(item=>item.quantity>0);
    if(!items.length)return;
    submit.disabled=true;submit.textContent='Adding to cart…';feedback.textContent='';
    try{
      const response=await fetch(root.dataset.cartAddUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      if(!response.ok){const error=await response.json().catch(()=>({}));throw new Error(error.description||error.message||'Unable to add these items. Check available stock and try again.')}
      window.location.href=root.dataset.cartUrl;
    }catch(error){feedback.textContent=error.message||'Could not add items. Please try again.';submit.textContent='Add selected styles to cart';refresh()}
  });
  refresh();
})();
